import React from 'react'

const AddedByIcon = () => {
    return (
        <svg
            className="added-by-icon"
            viewBox="-1 0 22 22"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
        >
            <path
                fill="currentColor"
                d="M14,6 C14,3.794 12.206,2 10,2 C7.794,2 6,3.794 6,6 C6,8.206 7.794,10 10,10 C12.206,10 14,8.206 14,6 Z M20,20 L15,20 L15,18 L17.784,18 C16.958,14.214 13.785,12 10,12 C6.215,12 3.042,14.214 2.216,18 L5,18 L5,20 L0,20 C0,15.445 2.583,12.048 6.242,10.673 C4.876,9.574 4,7.89 4,6 C4,2.686 6.686,0 10,0 C13.314,0 16,2.686 16,6 C16,7.89 15.124,9.574 13.758,10.673 C17.417,12.048 20,15.445 20,20 Z M11,18 L13,18 L13,20 L11,20 L11,22 L9,22 L9,20 L7,20 L7,18 L9,18 L9,16 L11,16 L11,18 Z"
            />
        </svg>
    )
}

export default AddedByIcon
